<template>
	<div class="round-tracker">
		<div class="label">Round</div>
		<div class="tracker">{{ currentRound }} of {{ totalRounds }}</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'RoundTracker',
	computed: {
		...mapState({
			index: (state) => state.game.rounds.index,
		}),
		currentRound() {
			return this.index + 1;
		},
		totalRounds() {
			return this.$store.getters["game/rounds/totalCount"];
		},
	},
};
</script>

<style lang="scss" scoped>
	.label {
		color: $primary-color-light;
		font-size: $font-size-sm;
	}

	.tracker {
		font-family: $heading-font;
		font-size: $font-size-lg;

		@include desktop { font-size: $font-size-xl; }
	}
</style>
